import {BaseService} from "../../infrastructure/domain-services/base-service";
import {BaseAnalyticsEvent} from "../../infrastructure/models/analytics/base-analytics-event";
import {AnalyticsUserDataEventModel} from "./analytics-user-data-event-model";
import {KinesisProvider} from "./kinesis/kinesis-provider";
import {GoogleAnalyticsProvider} from "./google-analytics/google-analytics-provider";
import {singleton} from "../../infrastructure/decorators/singleton";
import {KinesisManager} from "./kinesis/kinesis-manager";
import {BaseAnalyticsProvider} from "./base-analytics-provider";
import {BaseManager} from "../../infrastructure/managers/base-manager";
import {computed} from 'mobx';

@singleton
export class AnalyticsService extends BaseService {
  providers: Array<BaseAnalyticsProvider> = [];
  managers: Array<BaseManager> = [];
  onEventCreated = null;

  static injectables = [KinesisProvider, GoogleAnalyticsProvider, KinesisManager];

  constructor(
    kinesisProvider: KinesisProvider,
    googleAnalyticsProvider: GoogleAnalyticsProvider,
    kinesisManager: KinesisManager) {
    super();

    this.providers.push(kinesisProvider);
    this.providers.push(googleAnalyticsProvider);

    this.managers.push(kinesisManager);
  }

  get currentProvider() {
    return this.providers[0];
  }

  @computed get events(): Array<BaseAnalyticsEvent> {
    return this.currentProvider.events;
  }

  @computed get providerConsentGranted(): Array<BaseAnalyticsEvent> {
    return this.currentProvider.isVendorConsentGranted;
  }

  get userStreamEvents(): Array<BaseAnalyticsEvent> {
    return this.currentProvider.userDataHistory;
  }

  init() {
    if ("scheduler" in window) {
      window.scheduler.postTask(() => this.providers.forEach(p => p.init()), {priority: 'background'});
    } else {
      this.providers.forEach(p => p.init());
    }
  }

  async createEvent(event: BaseAnalyticsEvent) {
    if ("scheduler" in window) {
      window.scheduler.postTask(() => this.providers.map((provider: BaseAnalyticsProvider) => event.approvedProviders.includes(provider.name) && provider.createEvent(event)), {priority: 'background'});
    } else {
      this.providers.map((provider: BaseAnalyticsProvider) => event.approvedProviders.includes(provider.name) && provider.createEvent(event));
    }
  }

  flush() {
    this.providers.forEach(p => p.flush());
  }

  sendUserDataEvent(event: AnalyticsUserDataEventModel) {
    this.providers.map(p => p.sendUserData && p.sendUserData(event));
  }

}
